import React from 'react'

export default function Poligrafo() {
  return (
    <div>
      Poligrafo
    </div>
  )
}
